import type { CSSProperties } from 'react';
import { pxToRem } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

const SIZE = 24;

export interface PointerCSSProperties extends CSSProperties {
  '--pointer-custom-value': string;
}

export const container = css`
  position: absolute;
  width: ${pxToRem(SIZE * 2)};
  height: ${pxToRem(SIZE)};
  top: -${pxToRem(SIZE)};
  overflow: hidden;
  box-shadow: 0 ${pxToRem(16)} ${pxToRem(10)} ${pxToRem(-17)} rgba(0, 0, 0, 0.5);

  &[data-alignment='right'] {
    right: ${pxToRem(SIZE)};
  }

  &[data-alignment='center'] {
    left: calc(50% - ${pxToRem(SIZE)});
  }

  &[data-alignment='left'] {
    left: ${pxToRem(SIZE)};
  }

  &[data-alignment='custom'] {
    left: var(--pointer-custom-value);
  }
`;

export const pointer = css`
  content: '';
  position: absolute;
  width: ${pxToRem(SIZE)};
  height: ${pxToRem(SIZE)};
  background: var(--neutral-white-base);
  transform: rotate(45deg);
  top: ${pxToRem(SIZE / 2)};
  left: ${pxToRem(SIZE / 2)};
  box-shadow: ${pxToRem(-1)} ${pxToRem(-1)} ${pxToRem(10)} ${pxToRem(-2)} rgba(0, 0, 0, 0.5);
`;
